<template>
	<div class="input-container">
		<label :for="field">{{ label }}</label>
		<div class="input-wrapper">
			<div class="input-holder">
				<input
					:class="[{'input-error' : errors.length > 0}]"
					type="text"
					:id="field"
					v-model="newsletter[field]"
					:placeholder="placeholder"
					@focusout="validate"
				>
				<div class="errors" v-if="errors.length > 0" :key="$i18n.locale">
					<span v-for="(error, index) in errors" :key="index">
						{{ `${$t(`controlPanel.landingPage.errors.${error.name}`, error.min ? {min: error.min, max: error.max} : '')}` }}
					</span>
				</div>
			</div>

			<Hint
				:label="''"
				:hint="hint"
			/>
		</div>
	</div>
</template>

<script>
import Hint from "@/common/components/Hint";
import * as NewsletterFormService from "@/drc/services/newsletter.form.service";

export default {
	name: "NewsletterInput",
	components: {
		Hint
	},
	props: {
		newsletter: {
			type: Object,
			required: true
		},
		validations: {
			type: Object,
			required: true
		},
		field: {
			type: String,
			required: true
		},
		placeholder: {
			type: String,
			required: true
		},
		hint: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			errors: []
		}
	},
	methods: {
		validate() {
			this.errors = NewsletterFormService.validateInput(
				this.newsletter[this.field],
				NewsletterFormService.validations[this.field]
			);
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.input-container {
	display: flex;
	flex-direction: row;
	gap: 25px;
	row-gap: 5px;
	flex-wrap: wrap;
	width: 100%;

	label {
		font-family: "Roboto", sans-serif;
		color: $color-white-light;
		font-size: 14px;
		font-weight: 500;
		flex-basis: 20%;

		@media (max-width: 634px) {
			flex-basis: 100%;
		}
	}

	.input-wrapper {
		flex-basis: 75%;
		display: flex;
		flex-direction: row;
		gap: 5px;

		@media (max-width: 634px) {
			flex-basis: 100%;
		}

		.input-holder {
			flex-basis: 100%;

			input {
				font-family: "Roboto", sans-serif;
				color: $color-fotter-backgroud;
				font-size: 13px;
				font-weight: 400;
				background: $color-white-light;
				border: none;
				border-radius: 3px;
				padding: 3px 5px;
				outline: none;
				width: 100%;

				&.input-error {
					border: 1px solid red;
				}
			}

			.errors {
				display: flex;

				span {
					color: red;
					margin: 0;
					font-size: 12px;
					font-weight: 500;
					font-family: "Roboto", sans-serif;
					max-height: 15px;
				}
			}
		}
	}
}
</style>
